import { useQuery } from '@tanstack/react-query';
import type { AppointmentStatus, OnboardingStateView, OnboardingStatus } from '@barbeiropro/contracts';
import { api } from '@/lib/api';

export interface DashboardFinance {
  revenueCents: number;
  receivedCents: number;
  completedCount: number;
  pendingCents: number;
  averageTicketCents: number;
}

export interface Dashboard {
  date: string;
  timezone: string;
  onboarding: OnboardingStatus;
  agenda: {
    counts: Partial<Record<AppointmentStatus, number>>;
    total: number;
    upcoming: {
      id: string;
      startsAt: string;
      endsAt: string;
      status: AppointmentStatus;
      serviceName: string;
      barberName: string;
      barberColor: string;
      customerName: string;
    }[];
    occupancy: number | null;
    bookedMinutes: number;
    openMinutes: number;
  };
  finance?: {
    today: DashboardFinance;
    month: DashboardFinance;
    barbers: { id: string; name: string; color: string; goalCents: number | null; revenueCents: number; completed: number }[];
    openCashRegisters: { id: string; branchId: string; branchName: string; openedAt: string }[];
  };
  customers?: { inactive45: number; newThisMonth: number };
}

export const useDashboard = () =>
  useQuery({ queryKey: ['dashboard'], queryFn: () => api.get<Dashboard>('/dashboard'), refetchInterval: 60_000 });

export const onboardingStateKey = ['onboarding-state'] as const;
/** Checklist persistido (dispensado, dados de exemplo). */
export const useOnboardingState = () =>
  useQuery({ queryKey: onboardingStateKey, queryFn: () => api.get<OnboardingStateView>('/onboarding'), retry: false });
